import CloseIcon from '@mui/icons-material/Close'
import { Box, Container, useTheme } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

import * as React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import DirectionSnackbar from '../../../Components/Snackbar'
import RulesTable from './RulesTable'
import { makePostRequest } from 'utils/api'
import { makeGetRequest } from 'utils/api'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const AddRulesModal = React.forwardRef((props, ref) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const { handleChange } = props
  const [open, setOpen] = React.useState(false)
  const [rules, setRules] = React.useState([])
  const [openSnack, setOpenSnak] = React.useState({
    message: '',
    color: '',
    open: false,
  })

  React.useEffect(() => {
    fetchRules()
  }, [handleChange])
  React.useEffect(() => {
    fetchRules()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    handleChange()
  }

  React.useImperativeHandle(ref, () => ({
    handleClickOpen,
  }))

  const deleteRules = async (selected) => {
    const response = await makePostRequest(
      '/api/Finance/del/rules/',
      { selected: selected },
      {},
      true,
    )
    if (response.status === 200) {
      fetchRules()
      setOpenSnak({
        open: true,
        color: 'info',
        message: t('finance.categorisation.rules.snackbar.deleteSuccess'), // LAP-733 (GE022)
      })
      setTimeout(() => {
        setOpenSnak({
          open: false,
          color: 'success',
          message: t('finance.categorisation.rules.snackbar.addSuccess'), // LAP-733 (GE022)
        })
      }, 2000)
    }
  }

  const fetchRules = async (e) => {
    const { data } = await makeGetRequest('/api/Finance/RulesCatFI/', {}, true)
    setRules([...data])
  }
  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{ '.MuiDialog-paper': { backgroundColor: theme.palette.appBar.main } }}
      >
        {openSnack.open && (
          <DirectionSnackbar message={openSnack.message} color={openSnack.color} />
        )}
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: theme.palette.appBar.top,
          }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t('finance.categorisation.rules.title') /* LAP-733 (GE022) */}
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          style={{
            backgroundColor: theme.palette.appBar.main,
          }}
        >
          <Container>
            <RulesTable handleChange={handleChange} deleteCat={deleteRules} categories={rules} />
          </Container>
        </Box>
      </Dialog>
    </div>
  )
})
export default AddRulesModal
